import { ExamRequestInstance } from '@/Mixins/Class/ExamRequestInstance'
import srfRoutes from '@/Mixins/url/srf.json'

const routes = srfRoutes

export const page1Req = new ExamRequestInstance(
  routes,
  'fuj_pex',
  '/api/exam/auth/pre/refresh',
)

export const examReq = new ExamRequestInstance(
  routes,
  'fuj_ex',
  '/api/exam/auth/refresh',
)